module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Unauthorized user","text":"Sorry, but your user identity is not associated with any user account in this application."},"cs":{"title":"Nepovolaný uživatel","text":"Je nám líto, ale identita, kterou jste přihlášeni neodpovídá žádnému z účtů v této aplikaci"}}')
  delete Component.options._Ctor
}
